import {
  TrackReference,
  TrackLoop,
  VideoTrack,
  AudioTrack,
  useTracks,
  useParticipants,
} from '@livekit/components-react';
import { Track } from 'livekit-client';
import { useAdaptiveQuality } from './useAdaptiveQuality';

function getGridClass(count: number): string {
  if (count <= 1) return 'videocall-grid--1';
  if (count === 2) return 'videocall-grid--2';
  if (count <= 4) return 'videocall-grid--4';
  return 'videocall-grid--many';
}

export function VideoCallGrid() {
  const participants = useParticipants();
  const tracks = useTracks(
    [
      { source: Track.Source.Camera, withPlaceholder: true },
      { source: Track.Source.ScreenShare, withPlaceholder: false },
    ],
    { onlySubscribed: false },
  );
  useAdaptiveQuality(participants.length);

  const gridClass = getGridClass(tracks.length);

  return (
    <div className={`videocall-grid ${gridClass}`}>
      <TrackLoop tracks={tracks}>
        <TrackTile />
      </TrackLoop>
    </div>
  );
}

function TrackTile() {
  return (
    <div className="videocall-grid__tile">
      <VideoTrack />
      <AudioTrack />
      <ParticipantName />
    </div>
  );
}

function ParticipantName() {
  // Name overlay is handled via CSS in the tile
  return null;
}
